import { MenuActionBehavior, MenuConfig, MenuMode } from '@rappider/rappider-components/utils';

export enum WorkflowStepFunctionMode {
  Endpoint = 'endpoint',
  CustomFunctionDefinition = 'custom-function-definition',
  AiFunction = 'ai-function',
}

export enum WorkflowStepFunctionType {
  SplitOut = 'split-out',
  Router = 'router'
}

/* Note that we are mapping these options to BE WorkflowStepFunctionType. these are not one on one map to types */
export enum WorkflowStepFunctionTypeOption {
  AI = 'ai-function',
  Integrate = 'Integrate',
  AIGeneratedCustomFunction = 'ai-generated-custom-function',
  BlankFunction = 'blank-function',
  RouteWithConditions = 'route-with-conditions',
  ProjectEndpoints = 'project-endpoints',
  DataTransformation = 'data-transformation',
  HumanInTheLoop = 'human-in-the-loop'
}

/*


AI Function
Use AI in this step. Build autonomous agents, summarize or search documents, etc.

Integrate with Another App
Do something in another app or service like Google Sheets, Salesforce or Notion

AI Generated Custom Function
Generate a custom function using AI, just define what you want to do in this step

Blank Function
Blank function, you can define your own function in this step

Route with Conditions
Route the flow based on conditions

Project Endpoints
Run a pre-defined Rapider project endpoint. You can use your CRUD endpoints seamlessly

Data transformation
Transform, filter, sort data

Human in the loop
Wait for an approval or human input

*/

export const STEP_FUNCTION_TYPE_SELECTOR_MENU: MenuConfig = {
  items: [
    {
      label: 'AI',
      // tooltip: 'AI',
      key: WorkflowStepFunctionTypeOption.AI,
      description: 'Build autonomous agents, summarize or search documents, etc.',
      icon: {
        name: 'fa-regular fa-robot',
      },
      actionBehavior: MenuActionBehavior.Emit,
      children: []
    },
    {
      label: 'Integrate with Another App',
      // tooltip: 'integration-function',
      key: WorkflowStepFunctionTypeOption.Integrate,
      description: 'Do something in another app or service like Google Sheets, Salesforce or Notion',
      icon: {
        name: 'fa-regular fa-plug',
      },
      actionBehavior: MenuActionBehavior.Emit,
      children: []
    },
    {
      label: 'AI Generated Custom Function',
      // tooltip: 'AI Generated Custom Function',
      key: WorkflowStepFunctionTypeOption.AIGeneratedCustomFunction,
      description: 'Generate a custom function using AI, just define what you want to do in this step',
      icon: {
        name: 'fa-regular fa-sparkles',
      },
      actionBehavior: MenuActionBehavior.Emit,
      children: []
    },
    {
      label: 'Blank Function',
      // tooltip: 'Blank Function',
      key: WorkflowStepFunctionTypeOption.BlankFunction,
      description: 'Blank function, you can define your own function in this step',
      icon: {
        name: 'fa-regular fa-code',
      },
      actionBehavior: MenuActionBehavior.Emit,
      children: []
    },
    {
      label: 'Route with Conditions',
      // tooltip: 'Route with Conditions',
      key: WorkflowStepFunctionTypeOption.RouteWithConditions,
      description: 'Route the flow based on conditions',
      icon: {
        name: 'fa-regular fa-sign-post',
      },
      actionBehavior: MenuActionBehavior.Emit,
      children: []
    },
    {
      label: 'Project Endpoints',
      // tooltip: 'Project Endpoints',
      key: WorkflowStepFunctionTypeOption.ProjectEndpoints,
      description: 'Run a pre-defined Rapider project endpoint. You can use your CRUD endpoints seamlessly',
      icon: {
        name: 'fa-regular fa-bolt',
      },
      actionBehavior: MenuActionBehavior.Emit,
      children: []
    },
    {
      label: 'Data transformation',
      // tooltip: 'Data transformation',
      key: WorkflowStepFunctionTypeOption.DataTransformation,
      description: 'Transform, filter, sort data',
      icon: {
        name: 'fa-regular fa-filter',
      },
      actionBehavior: MenuActionBehavior.Emit,
      children: []
    },
    {
      label: 'Human in the loop',
      // tooltip: 'Human in the loop',
      key: WorkflowStepFunctionTypeOption.HumanInTheLoop,
      description: 'Wait for an approval or human input',
      icon: {
        name: 'fa-regular fa-user-check',
      },
      actionBehavior: MenuActionBehavior.Emit,
      children: []
    }
  ],
  mode: MenuMode.Vertical
};

export const INTEGRATION_FUNCTION_TEMPLATE_SELECTOR_MENU: MenuConfig = {
  items: [
    {
      label: 'Google Sheets',
      key: 'google-sheets',
      description: 'Integrate with Google Sheets',
      icon: {
        name: 'fa-brands fa-google'
      },
      actionBehavior: MenuActionBehavior.Emit,
      children: []
    },
    {
      label: 'Salesforce',
      key: 'salesforce',
      description: 'Integrate with Salesforce',
      icon: {
        name: 'fa-brands fa-salesforce'
      },
      actionBehavior: MenuActionBehavior.Emit,
      children: []
    },
    {
      label: 'Notion',
      key: 'notion',
      description: 'Integrate with Notion',
      icon: {
        name: 'fa-brands fa-notion'
      },
      actionBehavior: MenuActionBehavior.Emit,
      children: []
    }
  ],
  mode: MenuMode.Vertical
};
